<template>
    <div>
        <sign-in></sign-in>
    </div>
</template>

<script>
import SignIn from '../components/auth/SignIn.vue'

export default {
    components: {
        SignIn
    }
}
</script>